import { useState } from 'react';
import BasePlatformNumbersAccordion from './BasePlatformNumbersAccordion';

const EightByEightSection = ({
    errors,
    touched,
    submitData,
    setSubmitData,
    platformTrunks,
    platformID,
    ...props
}) => {
    const trunkList = Array.isArray(platformTrunks) ? platformTrunks : [];
    const trunkCount = trunkList.length;
    const isTrunkDisabled = trunkCount <= 0;
    const [isChecked, setIsChecked] = useState(
        !!submitData?.find((platform) => platform?.platformID === platformID)
            ?.trunkID || false,
    );

    return (
        <BasePlatformNumbersAccordion
            errors={errors}
            touched={touched}
            submitData={submitData}
            setSubmitData={setSubmitData}
            platformTrunks={platformTrunks}
            platformID={platformID}
            trunkList={trunkList}
            trunkCount={trunkCount}
            isTrunkDisabled={isTrunkDisabled}
            section="eightbyeight"
            isChecked={isChecked}
            setIsChecked={setIsChecked}
            {...props}
        />
    );
};

export default EightByEightSection;
